import { isArray } from '../../../../core/utils/utils';

export class SelectLabelService {

  concatLabel(labelArray, concatLabel: string, item, labelConfig) {
    let it = 0;
    if (labelArray && isArray(labelArray)) {
      labelArray.forEach(element => {
        it++;
        concatLabel += (item[element]);
        if (labelConfig && labelConfig.options && labelConfig.options.removeTailsAfter) {
          concatLabel = concatLabel.toString().split(labelConfig.options.removeTailsAfter)[0];
        }
        if (labelConfig && labelConfig.options && labelConfig.suffixes.hasOwnProperty(element)) {
          concatLabel += labelConfig.suffixes[element];
        }
        if (labelConfig && labelConfig.options && labelConfig.options.separateBy && it < labelArray.length) {
          concatLabel += labelConfig.options.separateBy;
        }
      });
    } else if (typeof labelArray === 'string') {
      concatLabel = item[labelArray];
    } else {
      concatLabel = item;
      if (labelConfig && labelConfig.options && labelConfig.options.removeTailsAfter) {
        concatLabel = concatLabel.toString().split(labelConfig.options.removeTailsAfter)[0];
      }
      if (labelConfig && labelConfig.suffix) {
        concatLabel += labelConfig.suffix;
      }
    }

    return concatLabel;
  }
}

